export enum CashAccountTypeCode {
  CACC = 'CACC',
  CARD = 'CARD',
  CASH = 'CASH',
  CHAR = 'CHAR',
  CISH = 'CISH',
  COMM = 'COMM',
  CPAC = 'CPAC',
  LLSV = 'LLSV',
  LOAN = 'LOAN',
  MGLD = 'MGLD',
  MOMA = 'MOMA',
  NREX = 'NREX',
  ODFT = 'ODFT',
  ONDP = 'ONDP',
  OTHR = 'OTHR',
  SACC = 'SACC',
  SLRY = 'SLRY',
  SVGS = 'SVGS',
  TAXE = 'TAXE',
  TRAN = 'TRAN',
  TRAS = 'TRAS',
  VACC = 'VACC',
  NFCA = 'NFCA',
  RFCA = 'RFCA',
  REFC = 'REFC',
  NLCY = 'NLCY',
  RLCY = 'RLCY',
}
